import { Stack, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { FiInbox } from 'react-icons/fi';

interface IOwnProps {
  children: ReactNode;
  title?: string;
}

const MessageBox: React.FC<IOwnProps> = ({ children, title }) => {
  return (
    <Stack h="100%" color="gray.500" justify="center" align="center" spacing={3} textAlign="center" py={10}>
      <FiInbox size={40} color="#A0AEC0" />
      <Text fontSize="lg" fontWeight="semibold">
        {title || 'Nenhum recurso disponível'}
      </Text>
      <Text color="gray.400" fontSize="sm">
        {children}
      </Text>
    </Stack>
  );
};

export default MessageBox;
